import _ from "lodash";
import { log } from "../../../Helper";
import { getAccessToken } from "../../../utils/okta-config";
import { API_ROOT } from "../../../constants/constants";

export async function getQualityHoldOrders(user) {
    try {
      let url = `${process.env.REACT_APP_API_ENDPOINT}/home/qualityHoldOrders`;
    
      const requestOptions = {
        method: "GET",
        headers: {
          supplierNumber: user.supplierNumber,
          isInternal: user.internal,
          Authorization: `Bearer ${getAccessToken()}`,
          "Access-Control-Allow-Origin": API_ROOT,
        },
      };
      const response = await fetch(url, requestOptions);
      if(response.status === 200){
        const result = await response.json();

        const tableData = result.content.map((order) => {
          if (null != order.avisDate && !_.isEqual(order.avisDate, "")) {
            order.avisDate = order.avisDate.replace("T", " ");
          }
          return order;
        });
        return tableData;
      }
    } catch (error) {
      log("Error while fetching quality hold orders-- ", error);
    }
  }